<div class="rounded-xl border border-primary-200 bg-primary-50 px-4 py-3">
  <h3 class="text-sm font-semibold text-primary-900 mb-2">
    <span translate>feature.ponctual-schedule.Votre sélection :</span>
    <span class="ml-1">({{ selections.length }})</span>
  </h3>

  <div class="space-y-2">
    @for (slot of selections; track slot.id; let i = $index) {
      <div class="flex items-center justify-between rounded-lg bg-white border border-primary-100 px-3 py-2">
        <div class="flex items-center gap-3">
          <mat-icon class="text-primary-600 !text-base">event</mat-icon>
          <span class="text-sm font-medium text-slate-800">
            {{ formatSlotDate(slot) }} • {{ formatSlotTime(slot) }}
          </span>
        </div>

        <button 
          (click)="onRemove(i)" 
          type="button"
          [disabled]="loading"
          class="inline-flex items-center justify-center w-7 h-7 rounded-full hover:bg-slate-100 text-slate-500 disabled:opacity-50"
          [attr.aria-label]="'Supprimer la sélection du ' + formatSlotDate(slot)">
          <mat-icon class="!text-base">close</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
